<template>
    <div class="container-fluid">
        <validation-observer v-slot="{ validate }" slim>
            <form @submit.prevent="update(validate)">
                <offer-form :form="form"/>
                <app-button :loading="loading" small>
                    {{ $t('Update') }}
                </app-button>
            </form>
        </validation-observer>
        <hr v-if="form.dbname"/>
        <div v-if="form.dbname" class="row">
            <div class="col">
                <div class="float-left" style="position: relative">
                    <span class="mdi mdi-24px mdi-trash-can-outline trash-img" @click="destroyImg"/>
                    <img :src="`${envUrl}/offers/${form.dbname}`" width="160px" height="auto" class="img-thumbnail"/>
                    <p>{{ form.filename | truncate }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SpecialOfferService from '@services/specialOffer.service';
import OfferForm from './components/Form';
import {mapGetters} from 'vuex';
import {fixDate} from '@services/helper.service';

export default {
    data() {
        return {
            form: {},
            loading: false
        };
    },
    watch: {
        locale() {
            this.getSpecialOffer(this.$route.params.offer_id);
        }
    },
    computed: {
        ...mapGetters(['envUrl', 'locale'])
    },
    methods: {
        destroyImg() {
            if (!window.confirm(`${this.$t('Delete')}?`)) {
                return false;
            }
            SpecialOfferService.destroyImg(this.form.id).then(res => {
                this.form.dbname = null;
                this.form.filename = null;
            });
        },
        update(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    SpecialOfferService.update(this.$route.params.offer_id, this.form).then(res => {
                        this.$toastr.s(this.$t('Updated'));
                        this.loading = false;
                        this.$router.push({name: 'specialoffers'});
                    });
                }
            });
        },
        getSpecialOffer(offerId) {
            SpecialOfferService.show(offerId).then(res => {
                this.form = res;
                this.form.start_date = fixDate(res.start_date);
                this.form.end_date = fixDate(res.end_date);
                this.form.vehicles = res.vehicles.map(veh => veh.id);
            });
        }
    },
    components: {
        OfferForm
    },
    created() {
        this.getSpecialOffer(this.$route.params.offer_id);
    }
};
</script>
